import styled from 'styled-components';

export const Title = styled.div`
	font-weight: 500;
	font-size: 19px;
	color: black;
	flex: 1;
`;

export const Header = styled.div`
	display: flex;
	align-items: center;
`;

export const ButtonWrapper = styled.div`
	margin-right: 16px;

	&:last-child {
		margin-right: 0;
	}
`;

export const LoadingContainer = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
`;

export const TableWrapper = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 40px;

	${Header} {
		padding-bottom: 16px;
	}
`;
